function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M5.68 18.44v1.85c0 .77.82 1.25 1.49.87l1.86-1.05c.94.27 1.93.41 2.96.41 5.52 0 10-4.15 10-9.26 0-5.11-4.48-9.26-10-9.26s-10 4.15-10 9.26c.01 2.89 1.45 5.48 3.69 7.18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.02 9.56l-2.54 3.02c-.31.37.03.92.5.81l2.01-.49c.13-.03.26-.01.37.05l1.01.59c.21.12.48.08.63-.11l2.5-2.99c.31-.37-.04-.93-.51-.8l-1.82.47a.5.5 0 01-.36-.04l-1.18-.62a.478.478 0 00-.61.11z"
})));